import React,{ Component } from 'react';

import { Button } from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';

class CampaignDCMForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isShowingPopover:false
    };
  }

  componentWillMount(){
    if(this.props.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const validationMessages = {};

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form onSubmit={(data) => this.handleSubmit(data)}>
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target='CampaignDCMInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='DCM Tag'
        >
          <p>
            Enter Double Click for Manager tag here.
          </p>
        </TutorialPopover>
        <TextInput
          id='CampaignDCMInput'
          name='dcmTag'
          multiline
          defaultValue={this.props.activeCampaignDCMTag}
          placeholder='Full tag or URL'
          warning={this.state.validationMessages['campaignDCMTag']}
        />
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignDCMForm.defaultProps = {
  isShowingTutorial:true
};

export default CampaignDCMForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignDCMForm.js